export const RECATEGORIZE_TITLE: string = 'Recategorize';
export const NEXT: string = 'Next';
export const WARNING_MESSAGE: string = 'Recategorizing the products may affect the categories associated with \'Rules\', \'Pivot\', \'Builder\' and \'Compatio Score\'.';
export const COMMON_ATTRIBUTES: string = 'Common Attributes';
export const COMMON_ATTRIBUTE_VALUES: string = 'Common Attribute Values';
export const UNIQUE_ATTRIBUTE_VALUES: string = 'Unique Attribute Values ';
export const UNIQUE_ATTRIBUTES_SOURCE: string = 'Unique Attributes (Source)';
export const UNIQUE_ATTRIBUTES_TARGET: string = 'Unique Attributes (Target)';
export const VIEW_ALL: string = 'View All';
export const MAPPED_OR_TRANSFERRED_ATTRIBUTE_VALUES: string = 'Mapped or Transferred Attribute Value';

export const attributeActions: AttributeActionOptions[] = [{ value: 'transfer', label: 'Transfer' }, { value: 'map', label: 'Map' }];
export const attributeValueActions: AttributeValueActionOptions[] = [{ value: 'create', label: 'Create' }, { value: 'map', label: 'Map' }];